import { Component, OnInit } from '@angular/core';
import { ChaseOrderStatus } from './Model/ChaseOrderStatus';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { OrderStatusService } from './Service/order-status.service';

@Component({
    selector: 'app-order-status',
    templateUrl: './order-status.component.html',
    styleUrls: ['./order-status.component.css'],
    providers: [OrderStatusService],
    standalone: false
})
export class OrderStatusComponent implements OnInit {

  uId: string;
  status: string;

  transactionStatus: ChaseOrderStatus = new ChaseOrderStatus();

  constructor(private location: Location, private router: Router, private orderStatusService: OrderStatusService) { }

  ngOnInit() {

    this.location.subscribe(change => {
      if(!change.url.includes("uId"))
        this.router.navigate(['Invoice']);
    });

    // debugger;
    this.uId = this.router.parseUrl(this.router.url).queryParams['uId'];

    this.orderStatusService.getTransactionStatusFromUID(this.uId).subscribe(
      (p: ChaseOrderStatus) => {
        // debugger;
        this.transactionStatus = p;
        if (this.transactionStatus.transactionStatus === 'Success') {
          this.status = 'Success';
        } else {
          this.status = 'Failure';
        }
      });
  }

  home() {
    this.router.navigate(['Invoice', 'order']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Media Pay - Order Payment</title>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );

    let btn = popupWin.document.getElementById('goToHome');
    btn.parentNode.removeChild(btn);
    popupWin.document.close();
  }

}
